import { useEffect } from "react";
import { useImmer } from "use-immer";

import {
  ShopifyTemplateTypeType,
  TemplateAssetType,
} from "@intelligems/ig-types";

import { useThemeAssets } from "./get-theme-assets";

const templateRegex = /^\w+\/\w+\.(json|liquid)/;

export const useThemeTemplates = (
  themeId?: string
): {
  isSuccess: boolean;
  data: { templates: TemplateAssetType[] };
} => {
  const [templates, setTemplates] = useImmer<TemplateAssetType[]>([]);

  const query = useThemeAssets("template", themeId);

  useEffect(() => {
    if (query.isSuccess) {
      setTemplates(
        query.data?.assets.map((asset) => ({
          ...asset,
          templateType: asset.key
            .split("/")[1]
            .split(".")[0] as ShopifyTemplateTypeType,
          isDefault: !!asset.key.match(templateRegex),
        })) || []
      );
    }
  }, [query.isSuccess, query.data]);

  return {
    isSuccess: query.isSuccess,
    data: { templates },
  };
};
